export default "__VITE_ASSET__CbzhqgRQ__"